<div
  class="d-flex flex-row-fluid flex-column justify-content-center text-center"
  style="height: 100vh"
>
  <h1 class="font-weight-boldest text-dark-75 mt-15" style="font-size: 10rem">
    404
  </h1>
  <p class="font-size-h3 text-muted font-weight-normal">
    OOPS! Something went wrong here
  </p>
</div>
